import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-12 mb-25" }
const _hoisted_3 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "row align-items-end g-3" }
const _hoisted_6 = { class: "col-md-4 col-sm-6" }
const _hoisted_7 = { class: "col-md-4 col-sm-6" }
const _hoisted_8 = { class: "col-md-4 col-sm-12 d-flex gap-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_11 = {
  key: 1,
  class: "ri-search-line me-1"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatsBoxes = _resolveComponent("StatsBoxes")!
  const _component_ParcelCharts = _resolveComponent("ParcelCharts")!
  const _component_UsersDataChart = _resolveComponent("UsersDataChart")!
  const _component_LastMonthsChart = _resolveComponent("LastMonthsChart")!

  return (_ctx.auth.can('HOME_PAGE'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "mb-20" }, "Statistiques Générals", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label fw-medium fs-13 text-uppercase text-dark-emphasis mb-1" }, " Date début ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchSDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.searchSDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label fw-medium fs-13 text-uppercase text-dark-emphasis mb-1" }, " Date fin ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchEDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.searchEDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "btn btn-primary fw-medium flex-fill",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.FilterData && _ctx.FilterData(...args))),
                    disabled: _ctx.isLoader
                  }, [
                    (_ctx.isLoader)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                      : (_openBlock(), _createElementBlock("i", _hoisted_11)),
                    _createTextVNode(" " + _toDisplayString(_ctx.isLoader ? "Chargement..." : "Chercher"), 1)
                  ], 8, _hoisted_9),
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger fw-medium flex-fill",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.ClearFilterData && _ctx.ClearFilterData(...args))),
                    disabled: _ctx.isLoader
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "ri-close-line me-1" }, null, -1),
                    _createTextVNode(" Annuler ", -1)
                  ]), 8, _hoisted_12)
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_StatsBoxes, { dashData: _ctx.dataDash }, null, 8, ["dashData"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_ParcelCharts)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_UsersDataChart)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_LastMonthsChart)
        ])
      ]))
    : _createCommentVNode("", true)
}